import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LanguageStore } from '../../language.store';
import { map } from 'rxjs/operators';
import {
  AcsProjectModel,
  CustomList
} from '../../../model/acs-project.model';
import { Observable } from 'rxjs';
import { ExpatClientResponse } from '../../../../core/api/models/expat-client-response';
import { ExpatProjectGetResponse } from '../../../../core/api/models/expat-project-get-response';
import { ExpatPricingResponse } from '../../../../core/api/models/expat-pricing-response';
import { ExpatPricing } from '../../../../core/api/models/expat-pricing';
import { DuplicateProjectRequest, SaveProjectRequest, TokenResponse, ValidateStepResponse } from '../dto';
import { environment } from '../../../../../environments/environment';
import { IAcsHttpService } from './acs-http-service.interface';

export interface CustomListResponse {
  status?: string;
  data: CustomList;
}

@Injectable({
  providedIn: 'root'
})
export class AcsHttpService implements IAcsHttpService{
  private languageStore = inject(LanguageStore);
  readonly http: HttpClient = inject(HttpClient);

  private get baseUrl(): string {
    const locale = this.languageStore.currentLanguageCode();
    return `${environment.apiBaseUrl}/${locale}/api/1.0/modules/acs/expat`;
  }

  public getCustomList() {
    return this.http
      .get<CustomListResponse>(`${this.baseUrl}/custom-lists`)
      .pipe(map((value) => value.data));
  }

  public getExpatClientInfos(uuid: string) {
    return this.http
      .get<ExpatClientResponse>(`${this.baseUrl}/client/${uuid}`)
      .pipe(map((value) => value.data));
  }

  public getProjectByUuid(token: string) {
    return this.http
      .get<ExpatProjectGetResponse>(`${this.baseUrl}/project/${token}`)
      .pipe(map((value) => value.data));
  }

  public postStep2(data: SaveProjectRequest) {
    return this.http
      .post<ValidateStepResponse>(`${this.baseUrl}/step/view-rates`, data)
      .pipe(map((value) => value.data));
  }

  public postStep3Save(data: SaveProjectRequest) {
    return this.http
      .post<ValidateStepResponse>(`${this.baseUrl}/step/draft`, data)
      .pipe(map((value) => value.data));
  }

  public postStep3Subscribe(data: SaveProjectRequest) {
    return this.http
      .post<ValidateStepResponse>(`${this.baseUrl}/step/pre-submit-subscribe`, data)
      .pipe(map((value) => value.data));
  }

  public postStep4(data: SaveProjectRequest) {
    return this.http
      .post<ValidateStepResponse>(`${this.baseUrl}/step/submit-subscribe`, data)
      .pipe(map((value) => value.data));
  }

  public postExpatTarificationCalculate(
    formatData: AcsProjectModel
  ): Observable<ExpatPricing> {
    return this.http
      .post<ExpatPricingResponse>(`${this.baseUrl}/pricing`, formatData)
      .pipe(map((value) => value.data));
  }

  public getInfoForNewProjectForSameClient(data: DuplicateProjectRequest, uuid: string): Observable<TokenResponse> {
    return this.http
      .post<TokenResponse>(`${this.baseUrl}/project/duplicate/${uuid}`, data);
  }
}
